import { useEffect, useState } from "react";
import { Users, Workflow } from "lucide-react";
import api from "@/lib/api";

const Mono = ({ children, className = "" }) => (
  <span className={`font-mono uppercase tracking-[0.2em] ${className}`}>{children}</span>
);

const FILTERS = [
  { key: "all", label: "All" },
  { key: "people", label: "People" },
  { key: "systems", label: "Systems" },
];

export default function ResourcesPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/resources").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const shown = filter === "all" ? items : items.filter((i) => i.category === filter);

  return (
    <div className="space-y-8 text-white" data-testid="resources-page">
      <div>
        <Mono className="text-gold-400 text-[0.65rem]">Sheet 05 — Library</Mono>
        <h1 className="font-heading font-light text-4xl tracking-tight mt-3">People &amp; Systems</h1>
        <p className="text-white/55 mt-3 font-light">Vetted specialists and ready-to-deploy frameworks to make your recovery delivery repeatable.</p>
      </div>

      <div className="flex items-center gap-2 border border-gold-500/25 bg-navy-900/40 p-1.5 w-fit">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            onClick={() => setFilter(f.key)}
            data-testid={`resfilter-${f.key}`}
            className={`px-5 py-2 text-sm rounded-sm transition-colors ${
              filter === f.key ? "bg-gold-500 text-navy-950 font-semibold" : "text-white/60 hover:text-white"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gold-500/15 border border-gold-500/15">
        {shown.map((r) => (
          <div key={r.id} className="bg-navy-900/60 p-6 hover:bg-navy-800 transition-colors" data-testid={`res-${r.id}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="h-10 w-10 border border-gold-500/30 flex items-center justify-center">
                {r.category === "people" ? <Users className="h-5 w-5 text-gold-400" /> : <Workflow className="h-5 w-5 text-gold-400" />}
              </div>
              <Mono className="text-white/40 text-[0.55rem]">{r.tag}</Mono>
            </div>
            <h3 className="font-heading text-xl">{r.title}</h3>
            <p className="text-sm text-white/55 mt-2 font-light">{r.description}</p>
            <div className="mt-4 pt-4 border-t border-gold-500/15 flex items-center justify-between">
              <Mono className="text-white/40 text-[0.55rem]">{r.category}</Mono>
              <span className="font-mono text-xs text-gold-400">{r.rate}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
